
import { computed, defineComponent, ref, onBeforeUnmount } from "vue";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"

export default defineComponent({
  name: "ModalEditarMarca",
  components: {
    Button
  },
  props: {
    fechaModal: Function,
  },
  setup(props) {
    const emitter = useEmitter();
    const loadSalvar = ref(false);
    const spanWarning = ref(false);
    const imagem = ref<HTMLInputElement>();
    const marcaForm: any = ref({
        id_marca_produto: null,
        nome: "",
        tipoProduto: "",
        imagem: "",
    });

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = marcaForm.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        marcaForm.value.imagem = file;
        marcaForm.value.imagemPreview = buildImagePreview(file);
      }
    }

    // abre o modal preenchendo dados quando receber o evento
    const openHandler = (payload: any) => {
      if (!payload?.marca) return;
      marcaForm.value = { ...payload.marca };
      marcaForm.value.imagemPreview = buildImagePreview(marcaForm.value.imagem);
    };

    const startHandler = () => {
      loadSalvar.value = true;
    };
    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      if (payload?.success) {
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("openEditMarca", openHandler);
      emitter.on("editMarca:start", startHandler);
      emitter.on("editMarca:finish", finishHandler);
    }

    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("openEditMarca", openHandler);
        emitter.off("editMarca:start", startHandler);
        emitter.off("editMarca:finish", finishHandler);
      }
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = null;
      }
    });

    // quando clicar salvar, emite para o pai
    async function onSave() {
      if (!marcaForm.value.tipoProduto || !marcaForm.value.nome) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;

      if (emitter && emitter.emit) {
        await emitter.emit("editMarca", { marca: marcaForm.value });
      }
      // não fecha aqui — Filtro controla fechamento quando receber finish
    }

    function openFileDialog() {
      imagem.value?.click();
    }

    return {
      marcaForm,
      handleImgFileChange,
      onSave,
      loadSalvar,
      spanWarning,
      fileName,
      openFileDialog,
      imagem,
    };
  }
});
